import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { DownloadTextVariablesCsvCommand } from "app/ApiClient";

export type TextVariablesDownloadToken = {
  token: string;
  command: DownloadTextVariablesCsvCommand;
};

export interface DownloadTextVariablesState {
  textVariablesDownloadingState: LoadingState;
  downloadTextVariablesErrorMessage?: string,
  textVariablesDownloadTokens: TextVariablesDownloadToken[],
}
export const initialDownloadTextVariables: DownloadTextVariablesState = {
  textVariablesDownloadingState: LoadingState.idle,
  textVariablesDownloadTokens: [],
};
